<template>
  <div class="Searchbar">
    <input
      @input="handleChange"
      class="SearchbarInput"
      type="text"
      name="query"
      :value="getSortQuery"
      placeholder="Search..."
    />
    <img
      class="SearchbarIcon"
      src="../assets/img/search.svg"
      alt="search bar icon"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Searchbar",
  methods: {
    ...mapActions(["updateSortQuery"]),
    handleChange(e) {
      let query = e.target.value.trim();
      this.updateSortQuery(query);
    },
  },

  computed: {
    ...mapGetters(["getSortQuery"]),
  },
};
</script>

<style lang="scss" scoped>
.Searchbar {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 5px 20px;
  border: 1px solid $color-light-grey;
  border-radius: 45px;
  box-sizing: border-box;
  .SearchbarInput {
    font-family: $font-primary;
    font-size: 14px;
    padding-right: 10px;
    width: 98%;
    border: none;
  }
  .SearchbarIcon {
    width: 14px;
  }
}
</style>
